import "./App.css";
import { List } from "./List";

function App() {
  return (
    <div id="App">
      <List />
    </div>
  );
}

export default App;
